// src/pics.jsx
const images = {
    BANNER_IMAGE: require('./Assets/banner.png'),
    SIMPLIFY_BOOKING: require('./Assets/simplified.gif'),
    PICKUP: require('./Assets/pickup.gif'),
    DELIVERED: require('./Assets/delivered.gif'),
    DOMESTIC: require('./Assets/domesticourier.gif'),
    D2DCARGO: require('./Assets/d2daircargo.gif'),
    SAMEDAY: require('./Assets/samedaydelivery.gif'),
    CHARTED: require('./Assets/charterflight.gif'),
    VIDEO_SECT: require('./Assets/video.mp4'),
    ABOUT_SECT: require('./Assets/aboutus.png'),
    MAIL: require('./Assets/mail.gif'),
    MOBILE: require('./Assets/mobile.gif'),
    TIME: require('./Assets/time.gif'),
    PLACE: require('./Assets/place.gif'),
    BUSINESS: require('./Assets/businessquery.png'),
    AIRPORT: require('./Assets/airport.gif'),
    WHYUS: require('./Assets/whyus.png'),
    LOGO: require('./Assets/logo.png'),
    FEEDBACK: require('./Assets/feed_back.png'),
    FRANCHISEE: require('./Assets/franchise.png'),
    WHITE_LOGO: require('./Assets/Logo2.png'),
    SERVICEPAGE: require('./Assets/servicepage.png'),
    CAREER_POSTER: require('./Assets/poster.gif')
  };
  
  export default images;
  